export default "__VITE_ASSET__21e460f4__"